'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";
import ProjectSupportModalCreateController from "./controller/projectSupportModalCreate";
import ProjectSupportTableDirective from "./directive/projectSupportTable";
import ProjectSupportService from "./service/projectSupport";

export default angular.module('investmentProject.project.support', [])
    .controller('ProjectSupportModalCreateController', ProjectSupportModalCreateController)
    .directive('projectSupportTable', ProjectSupportTableDirective)
    .factory('ProjectSupportService', ProjectSupportService)
    .name;
